import React from 'react';

const HowToGuideModal = () => {
  return (
    <>
      <p>Definitions and descriptions calculator fields. </p>
      <ul className="iLendingCDX-modal-content__list">
        <li>
          <b>Remaining Loan Balance:</b> Total amount remaining and owed on your current vehicle loan.
        </li>
        <li>
          <b>Current Monthly Payment:</b> Dollar amount of your vehicle payment you are currently making.
        </li>
        <li>
          <b>Payments Remaining:</b> Number of months left to pay on your current vehicle loan.
        </li>
        <li>
          <b>Current Interest Rate:</b> Current Interest Rate on your current vehicle loan.
        </li>
        <li>
          <b>Estimated Credit Score:</b> Provide your best estimate for your current Credit/FICO score.
        </li>
      </ul>
      <p>Still have questions? </p>
      <p>Call 888.888.8888</p>
    </>
  );
};

export default HowToGuideModal;
